const Howitworks = () => {
  return (
    <div>
      <h2 className="howitworks">How it works</h2>
      <div className="howitworks-container">
        <div className="wrapper">
          <span className="howitworks-number">1</span>
          <div className="howitworks-description">
            <h4 className="howitworks-heading">Your vehicle details</h4>
            <p className="howitworks-paragraph">
              Enter your registration number and tell us about your vehicle by filling out our simple form.
            </p>
          </div>
        </div>
        <div className="wrapper">
          <span className="howitworks-number">2</span>
          <div className="howitworks-description">
            <h4 className="howitworks-heading">Get your valuation</h4>
            <p className="howitworks-paragraph">
              You will get an instant, free, no-obligation valuation using the latest market data. We will then contact you to discuss your vehicle.
            </p>
          </div>
        </div>
        <div className="wrapper">
          <span className="howitworks-number">3</span>
          <div className="howitworks-description">
            <h4 className="howitworks-heading">Sell your vehicle</h4>
            <p className="howitworks-paragraph">
              One of our advisors will confirm an appointment and arrange everything for you.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Howitworks }
